module.exports = __webpack_public_path__ + "channel_3.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/assets/channel_3.png
// module id = 1125
// module chunks = 10